import { render, staticRenderFns } from "./RappiStores.vue?vue&type=template&id=48367ff4"
import script from "./RappiStores.vue?vue&type=script&lang=js"
export * from "./RappiStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports